import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/Assets-V4/PhysicalSecurity/g6-ptz@2x.jpg";
import v3Image from "../../assets/PTZ/g6-ptz.jpg";
import type { Product } from "../../types";
import { ptz } from "../product-groups/cameraSecurity/Ptz";
import { ptz as productListGroupPTZ } from "../product-list-groups/ptz";

export const g6Ptz: Product = {
  id: "g6Ptz",
  productTitle: "G6 PTZ",
  description: "g6Ptz.description",
  isNew: true,
  techspecsPath: [SiteId.TechSpecs, `/unifi/cameras-nvrs/uvc-g6-ptz`],
  storePathParts: {
    productSlug: "uvc-g6-ptz",
    category: "cameras-ptz",
  },
  image: { src: image, width: 200, height: 140 },
  v3Image: {
    src: v3Image,
    width: 200,
    height: 182,
  },
  productGroup: ptz,
  productListGroup: productListGroupPTZ,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "translation",
        value: "g6Ptz.dimensions",
      },
    },
    {
      propertyId: "cameraResolution",
      value: { type: "string", value: "4K" },
    },
    {
      propertyId: "imageSensor",
      value: { type: "translation", value: "g6Ptz.imageSensor" },
    },
    {
      propertyId: "fieldOfView",
      value: {
        type: "translation",
        value: "g6Ptz.fieldOfView",
      },
    },
    {
      propertyId: "nightVision",
      value: { type: "string", value: "30 m (98 ft)" },
    },
    {
      propertyId: "opticalZoom",
      value: {
        type: "translation",
        value: "g6Ptz.opticalZoom",
      },
    },
    {
      propertyId: "smartDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "enhancedDetections",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "licensePlateRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "aiRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "faceRecognition",
      value: { type: "boolean", value: true },
    },
    {
      propertyId: "cameraAudio",
      value: { type: "translation", value: "commons.cameraAudio.twoWayAudio" },
    },
    {
      propertyId: "outdoorReady",
      value: { type: "string", value: "IP66" },
    },
    {
      propertyId: "tamperResistance",
      value: { type: "string", value: "IK04" },
    },
    {
      propertyId: "deployment",
      value: { type: "string", value: "PoE+" },
    },
  ],
};
